import axios from '@/js/lib/helper/axios';
import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';

export interface TodoItem {
  picturePath?: string;
  tag: string | null;
  text: string;
  timestamp: string;
  type: string;
  url: string;
  expireAt?: string;
}

export const getTodos = async (): Promise<{ todos: TodoItem[]; totalCount: number }> => {
  const res = await axios.get('/api/todo/list');

  return {
    todos: toCamelCaseKeys(res.data),
    totalCount: Number(res.headers['x-total-count']),
  };
};
